<template>
  <div class="data_table">
    <jt-data-table
      ref="table"
      class="jt-datatable no-shadow table_header cadri_table"
      v-bind="$props"
      @action-button="onActionButtonHandler"
      @selection="onSelectedUpdate"
    >
     <template v-slot:header="{props}">
      <q-tr :props="{props}">
        <q-th v-if="!noneselect && !rowButtons" auto-width />
        <q-th v-for="col in props.cols" :key="col.name" :props="props">
          <div :class="handleSortCols({ col: col})">
          </div>
          {{ col.label }}
        </q-th>
        <q-th style="width: 1px" v-if="buttons.length > 0 && rowButtons" />
      </q-tr>
    </template>
      <template v-slot:body="{ props }">
        <q-tr :props="{ props }">
          <q-td v-if="!noneselect && !rowButtons" auto-width>
            <q-checkbox v-model="props.selected" color="primary" />
          </q-td>
          <q-td
            v-for="col in props.cols"
            :key="col.name"
            :props="props"
          >
            <span v-if="col.model == 'endDate'">
              <div v-bind:class="getClassStatusFromDays(props.row['endDate'])">
                {{ props.row[col.model] }}
              </div>
            </span>
            <span class="text-no-wrap" v-else-if="col.model == 'generator'">
              <div>
                {{ getGenerator(props) }}
              </div>
              <span class="aditional-infos">
                {{ getDocument(props) }}
              </span>
            </span>
            <div v-bind:class="getClassStatusFromRemaningPercent(props)"  v-else-if="col.model == 'wasteCertifiedBoundResidues'">
              <span  class="text-no-wrap block">
                {{ getResidue(props) }}
              </span>
              <span class="aditional-infos ">
                {{ getResiduePercent(props) }}
              </span>
            </div>
            <div v-else-if="col.model == 'available'">
              <div :class="getResidueStatus(props.row)">
                <span :class="getAvailableStatus(props.row)">{{ props.row[col.model] ? $gettext("LABEL_TRUE") : $gettext("LABEL_FALSE") }}</span>
              </div>
            </div>
            <span v-else-if="col.model == 'release'">
              <q-btn
                v-if="props.row['protocolFile']"
                flat
                round
                color="primary"
                class="q-mr-sm"
                icon="assignment_turned_in"
                @click="showDocument(props.row)"
              />
            </span>
            <span v-else-if="!col.edit">
              {{ formatedValue(col) }}
            </span>
            <q-toggle
              v-else-if="col.type == 'CHECKBOX'"
              v-model="props.row[col.model]"
            />
            <span v-else>
              {{ props.row[col.model] }}
              <i class="fas fa-pencil-alt material-icons" />
              <q-popup-edit v-model="row[col.model]" auto-save>
                <jt-input
                  v-model="props.row[col.model]"
                  :type="col.type.toLowerCase()"
                  :name="col.model"
                />
              </q-popup-edit>
            </span>
            <q-btn
              v-if="col.name === 'showhide'"
              flat
              round
              color="primary"
              class="q-mr-sm"
              :icon="
                props.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
              "
              @click="props.expand = !props.expand"
            />
          </q-td>
        </q-tr>
        <q-tr v-show="props.expand" :props="props">
          <q-td colspan="100%">
            <div class="row hidden-row">
              <div v-for="(col, key) in hiddenColumns" :key="key" class="col-6">
                <label>{{ col.label }}:</label>
                {{ props.row[col.model] }}
              </div>
            </div>
          </q-td>
        </q-tr>
      </template>
    </jt-data-table>
    <jt-docs-viewer
      v-if="showDoc"
      ref="docsModal"
      pdf
      :src="src"
      @hide="closeDoc"
    />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable, JtDocs } from 'jtech-webcomps'
import { repository } from 'jtech'
import moment from 'moment'

@Component({
  name: 'cadriDataTable',
  mixins: [JtDataTable],
  components: { jtDocsViewer: JtDocs.JtDocsViewer },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
export default class CadriDataTable extends Vue {
  showDoc = false
  src = null

  getWasteCertifiedBoundResiduesMinPercent (props) {
    return props.row.wasteCertifiedBoundResidues.reduce((wasteCertifiedBoundResidues, current) => {
      return +wasteCertifiedBoundResidues.quantityRemainingInPercent < current.quantityRemainingInPercent ? wasteCertifiedBoundResidues : current
    })
  }

  getResiduePercent (props) {
    const wasteCertifiedBoundResiduesMinPercent = this.getWasteCertifiedBoundResiduesMinPercent(props)
    const quantityRemaining = wasteCertifiedBoundResiduesMinPercent.quantityRemaining
    return `${wasteCertifiedBoundResiduesMinPercent.quantityRemainingInPercent}% / ${Number(quantityRemaining?.replaceAll(',', '.')).toFixed(2).toString().replaceAll('.', ',')} de ${Number(wasteCertifiedBoundResiduesMinPercent.quantityGeneration?.replaceAll(',', '.')).toFixed(2).toString().replaceAll('.', ',')}`
  }

  getResidue (props) {
    const wasteCertifiedBoundResiduesMinPercent = this.getWasteCertifiedBoundResiduesMinPercent(props)
    return wasteCertifiedBoundResiduesMinPercent.residue
  }

  getGenerator (props) {
    const wasteCertifiedBoundResiduesMinPercent = this.getWasteCertifiedBoundResiduesMinPercent(props)
    return wasteCertifiedBoundResiduesMinPercent.generator
  }

  getDocument (props) {
    const wasteCertifiedBoundResiduesMinPercent = this.getWasteCertifiedBoundResiduesMinPercent(props)
    return wasteCertifiedBoundResiduesMinPercent.document
  }

  async showDocument (row) {
    const nmIdentificacaoParserFile = 'WASTE_CERTIFIED_LIBERATION_DOCUMENT_FILE'

    const file = await repository.downloadFile(
      row.protocolFile,
      null,
      nmIdentificacaoParserFile
    )
    document.createElement('a')
    this.src = URL.createObjectURL(file)
    this.showDoc = true
    this.$nextTick(() => {
      this.$refs.docsModal.show()
    })
  }

  closeDoc () {
    this.showDoc = false
  }

  getClassStatusFromDays (endDate) {
    const dateSplited = endDate.split('/')
    const dateMoment = moment([dateSplited[2], dateSplited[1] - 1, dateSplited[0]])
    const days = dateMoment.diff(moment(new Date()), 'days')
    return {
      red: days < 0,
      yellow: days <= 30 && days >= 0,
      blue: days <= 60 && days > 30
    }
  }

  getClassStatusFromRemaningPercent (props) {
    const wasteCertifiedBoundResiduesMinPercent = this.getWasteCertifiedBoundResiduesMinPercent(props)
    const quantityRemainingInPercent = +wasteCertifiedBoundResiduesMinPercent.quantityRemainingInPercent
    return {
      red: quantityRemainingInPercent <= 0,
      yellow: quantityRemainingInPercent > 0 && quantityRemainingInPercent <= 10,
      blue: quantityRemainingInPercent > 10 && quantityRemainingInPercent <= 30
    }
  }

  handleSortCols ({ col, props }) {
    if (
      ['generator', 'release', 'wasteCertifiedBoundResidues'].includes(
        col.name
      )
    ) {
      col.sortable = false
    }
  }

  getAvailableStatus (row) {
    return row.available ? 'green-text' : 'red-text'
  }

  getResidueStatus (row) {
    return row.inactiveResidue ? 'highlight-inactive' : ''
  }
}
</script>
<style scoped lang="stylus">
@import '~quasar-variables';

.aditional-infos {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.05);
  font-size: 0.7rem
  padding 3px;
}

.cadri_table {
  height: 45vh !important;
}

.red {
  background: #ff000138;
  padding: 7px;
}

.blue {
  background: #7abcce54;
  padding: 7px;
}

.yellow {
  background: #ffd6163b;
  padding: 7px;
}

.green-text {
  color: #26A69A;
  font-weight: bold;
}

.red-text {
  color: #f44336;
  font-weight: bold;
}

.highlight-inactive{
  color: $secondary!important;
  background: #ffe0b5;
  padding: 7px;
}

.jt-datatable {
  .hidden-row > div {
    width: 100%;
    padding: 5px 12px;
  }

  .hidden-row > div:nth-child(odd) {
    background-color: $grey-3;
  }

  .q-table--no-wrap td {
    white-space: inherit !important;
  }
}
</style>
